module.exports = __webpack_public_path__ + "static/kam-chauhan-social-media-117-121556cfe067ea97d3b59167747c5e90.jpg";